import Immutable from 'seamless-immutable'
import { TableModel } from '../models/TableModel'
import { types } from '../actions/advertisementsActions'

const initialState = Immutable({
  pagedData: new TableModel(
    { pageNumber: 1, pageSize: 20 },
    [{ id: 'createdAt', value: 'desc' }],
    []
  ),
  error: false
})

export default function advertisementsReducer (state = initialState, action) {
  switch (action.type) {
    case types.LOAD_ADVERTISEMENTS:
      return state.merge({
        error: false,
        pagedData: TableModel.pageRequested(
          state.pagedData,
          action.pageNumber,
          action.pageSize,
          action.filterBy,
          action.sortBy
        )
      })
    case types.LOAD_ADVERTISEMENTS_SUCCESS:
      return state.merge({
        pagedData: TableModel.pageReady(
          state.pagedData,
          action.result.totalDataCount,
          action.result.data || []
        )
      })
    case types.LOAD_ADVERTISEMENTS_FAILURE:
      return state.merge({
        error: true,
        pagedData: { ...state.pagedData, loading: false }
      })
    default:
      return state
  }
}
